<template>
    <div class="option-wrapper">
        <span class="op">
            <i class="transfer" @mousedown="transPosition"></i>
        </span>
        <i class="delete" @click="deleteOption"></i>
        <input
            :placeholder="placeHolder"
            class="option-name"
            :class="{ 'recommend-option': data.recommend, 'rtl': isArabic }"
            v-model="optionName"
            @input="keyPressHandler"
        />
        <div class="option-question" @mouseover="mouseOnQuestion" @mouseout="mouseOutQuestion" @click="questionClick">
            {{ data.question || defaultQuestion }}
        </div>
        <QuestionSimpleView v-if="showSimple" :questionId="data.questionId" :content="simpleContent" @onview="mouseOnQuestion" @outview="mouseOutQuestion" />
    </div>
</template>

<script>
import QuestionSimpleView from "./QuestionSimpleView";
import { isArabicText } from "@/views/zhiji/js/common/util.js";
import i18n from "@/i18n";

export default {
    name: "Option",
    props: ["data", "isDraging"],
    components: {
        QuestionSimpleView,
    },
    data() {
        return {
            optionName: this.data.name,
            isShowSimple: false,
            isTransfer: false,
            simpleContent: "",
            isArabic: false
        };
    },
    computed: {
        showSimple() {
            return this.isShowSimple && !this.isDraging && !!this.simpleContent;
        },
        placeHolder() {
            return this.$t("zhiji.answer.enterTip");
        },
        defaultQuestion() {
            return this.$t("zhiji.answer.clickLinkQues");
        }
    },
    methods: {
        transPosition(event) {
            this.$emit("draging", true);

            this.zhiji.dragStart(event, "option-wrapper", "h", newIdx => {
                this.$emit("draging", false);

                this.$store.commit("zhiji/editQsUpdateAnswer", {
                    type: "tranferOption",
                    option: {
                        newIdx: newIdx,
                        uId: this.data.uId
                    }
                });
            });
        },
        deleteOption() {
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "deleteOption",
                option: this.data
            });
        },
        keyPressHandler(data) {
            this.isArabic = isArabicText(data.target.value);
            const newName = this.zhiji.strTrim(this.optionName);
            const isChanged = newName != this.data.name;

            if (newName && isChanged) {
                this.optionName = newName;
                this.$store.commit("zhiji/editQsUpdateAnswer", {
                    type: "updateOption",
                    option: {
                        name: newName,
                        uId: this.data.uId
                    }
                });
            }
        },
        mouseOnQuestion() {
            this.simpleTimeout && clearTimeout(this.simpleTimeout);
            this.simpleTimeout = setTimeout(() => {
                this.isShowSimple = true;

                this.data.questionId &&
                    this.zhiji
                        .requestByServiceName("queryQuesSimpleById", {
                            questionId: this.data.questionId
                        })
                        .then(resp => {
                            this.simpleContent = resp.answerText;
                        });
            }, 500);
        },
        mouseOutQuestion() {
            this.simpleTimeout && clearTimeout(this.simpleTimeout);
            this.simpleTimeout = setTimeout(() => {
                this.isShowSimple = false;
            }, 500);
        },
        questionClick() {
            this.$store.dispatch("zhiji/showModal", {
                type: "QuestionSelectorTableModal",
                data: {
                    title: i18n.t("zhiji.answer.textWidget.linkQuestion"),
                    questionId: parseInt(this.data.questionId),
                    currentLang: this.$store.state.zhiji.questionEdit.currentSynonym,
                    confirm: data => {
                        this.questionSelected(data);
                    }
                }
            });
        },
        questionSelected(data) {
            if (!data.question) {
                return;
            }
            let option = {
                question: data.question,
                questionId: data.questionId,
                uId: this.data.uId,
                name: data.optionTip
            };
            this.optionName = data.optionTip;
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "updateOption",
                option: option
            });
        }
    }
};
</script>

<style lang="less" scoped>
.option-wrapper {
    position: relative;
    max-width: 208px;
    margin: 0 20px 16px 0;
    flex-shrink: 0;
    box-sizing: border-box;

    .op {
        position: absolute;
        top: 2px;
        left: -10px;
        cursor: pointer;
        display: inline-flex;
        width: 26px;
        height: 26px;
        border-radius: 50%;
        align-items: center;
        justify-content: center;
        box-shadow: 0px 2px 6px rgba(46, 98, 151, 0.2);
        background: #fff;
        display: none;
    }
    .recommend-option {
        background-color: #d9ebf6;
    }
    .transfer {
        position: relative;
        display: inline-block;
        width: 18px;
        height: 13px;
        vertical-align: middle;
        background: url("@{zhijiStaticImagePath}class-spr.png");
        background-position: -321px -18px;

        &:hover {
            background-position: -321px -34px;
        }
    }

    .delete {
        position: absolute;
        right: 3px;
        top: -3px;
        width: 18px;
        height: 18px;
        background: url("@{zhijiStaticImagePath}class-spr.png") -4px -1px;
        display: none;

        &:hover {
            background-position: -252px -20px;
        }
    }

    &:hover {
        .op {
            display: inline-flex;
        }

        .delete {
            display: inline-block;
        }
    }

    .option-name {
        width: 100%;
        padding: 6px 20px;
        border-radius: 20px;
        border: 1px solid #d8e4f0;
        font-size: 12px;

        &:focus {
            border-color: #2088f3;
            box-shadow: 0 0 8px rgba(90, 98, 111, 0.25);
        }
    }

    &.moving {
        user-select: none;

        .option-name {
            background: #d9ebf6;
            cursor: pointer;
        }
    }

    .rtl {
        direction: rtl;
    }

    .option-question {
        position: relative;
        width: 100%;
        padding: 3px 12px;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        border-bottom: 1px solid #2ec2ff;

        &:hover {
            color: #2ec2ff;
            cursor: pointer;
        }
    }
}
</style>
